import { useEffect } from "react"
import useSound from "use-sound"
import stellarMusicSFX from "../lib/audio/stellar-music.mp3"

export const handleplayStellarSFX = (
  isMusicOff: any,
  music: any,
  isError: any,
  isLoading: any,
  state: any,
  disableSounds: any,
  errorText: any,
  isJackpot: any,
) => {
  const [playStellarMusicSFX, { stop, sound: engineSound }] = useSound(stellarMusicSFX, {
    volume: parseFloat(music) / 100 >= 0.2 ? 0.2 : parseFloat(music) / 100,
  })

  useEffect(() => {
    if (errorText !== "" && isJackpot) {
      stop()
    }
  }, [errorText, isJackpot])

  useEffect(() => {
    !isMusicOff &&
      !isError &&
      !isLoading &&
      state === 2 &&
      !disableSounds &&
      !isJackpot
      ? (() => {
        playStellarMusicSFX()
        engineSound && engineSound.loop(true)
      })()
      : stop()
  }, [
    isMusicOff,
    playStellarMusicSFX,
    stop,
    music,
    isError,
    isLoading,
    state,
    disableSounds,
    isJackpot,
  ])
}
